"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function SvgPaymentReturn(props) {
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.449 21.23h2.533s-.03-12.29-.03-13.254c0-.964 0-.964.998-.964h4.03c1.02 0 1.02 0 1.02.988s.03 13.23.03 13.23h2.517c.42 0 .647.341.237.726-.41.384-1.453 1.353-5.008 4.683-.522.49-1.045.474-1.551 0-3.538-3.315-4.65-4.333-5.023-4.683-.374-.35-.192-.726.247-.726z", fill: "currentColor" }, void 0), (0, jsx_runtime_1.jsx)("path", { fill: "currentColor", d: "M5 15h10v4H5zM25 15h10v4H25z" }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M26 11h5.25c2.071 0 3.75 1.612 3.75 3.6v10.8c0 1.988-1.679 3.6-3.75 3.6H8.75C6.679 29 5 27.388 5 25.4V14.6C5 12.612 6.679 11 8.75 11H14", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }, void 0)] }), void 0));
}
exports.default = SvgPaymentReturn;
//# sourceMappingURL=PaymentReturn.js.map